// BOQBOX storefront UI kit. Styles: src/styles/bx.css. Colours: src/styles/theme.css.
import React, { useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useTheme } from '../../hooks/useTheme';

const logo = require('../../assets/images/BOQBOXLogoTwo.png');

// ---------- icons ----------
const PATHS: Record<string, React.ReactNode> = {
  back: <path d="m15 18-6-6 6-6" />,
  arrow: <><path d="M5 12h14" /><path d="m13 6 6 6-6 6" /></>,
  sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></>,
  moon: <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />,
  bag: <><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" /><path d="M3 6h18" /><path d="M16 10a4 4 0 0 1-8 0" /></>,
  search: <><circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" /></>,
  plus: <><path d="M12 5v14" /><path d="M5 12h14" /></>,
  check: <path d="M20 6 9 17l-5-5" />,
  bolt: <path d="M13 2 3 14h7l-1 8 10-12h-7l1-8Z" />,
  repeat: <><path d="m17 2 4 4-4 4" /><path d="M3 11v-1a4 4 0 0 1 4-4h14" /><path d="m7 22-4-4 4-4" /><path d="M21 13v1a4 4 0 0 1-4 4H3" /></>,
  gift: <><rect x="3" y="8" width="18" height="4" rx="1" /><path d="M12 8v13" /><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" /><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5" /></>,
  shield: <path d="M20 13c0 5-3.5 7.5-7.7 9a1 1 0 0 1-.6 0C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.2-2.7a1.2 1.2 0 0 1 1.6 0C14.5 3.8 17 5 19 5a1 1 0 0 1 1 1Z" />,
  truck: <><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" /><path d="M15 18H9" /><path d="M19 18h2a1 1 0 0 0 1-1v-3.6a1 1 0 0 0-.2-.6l-3.5-4.4a1 1 0 0 0-.8-.4H14" /><circle cx="17" cy="18" r="2" /><circle cx="7" cy="18" r="2" /></>,
  store: <><path d="M2 7 6.4 2.6A2 2 0 0 1 7.8 2h8.4a2 2 0 0 1 1.4.6L22 7" /><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" /><path d="M2 7h20v3a2 2 0 0 1-2 2 2.7 2.7 0 0 1-2-1 2.7 2.7 0 0 1-4 0 2.7 2.7 0 0 1-4 0 2.7 2.7 0 0 1-4 0 2.7 2.7 0 0 1-2 1 2 2 0 0 1-2-2Z" /></>,
  user: <><circle cx="12" cy="8" r="4.5" /><path d="M20 21a8 8 0 0 0-16 0" /></>,
  pin: <><path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" /></>,
  lock: <><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></>,
  star: <path d="m12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1Z" />,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  x: <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>,
  edit: <><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" /></>,
  utensils: <><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" /></>,
  leaf: <><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.5 19 2c1 2 2 4.2 2 8 0 5.5-4.8 10-10 10Z" /><path d="M2 21c0-3 1.9-5.4 5.1-6" /></>,
};

export function Icon({ name, size = 18, stroke = 2 }: { name: keyof typeof PATHS | string; size?: number; stroke?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {PATHS[name] || PATHS.bag}
    </svg>
  );
}

// ---------- theme ----------
export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';
  return (
    <button type="button" className="bx-icon-btn" onClick={toggle} aria-label={`Switch to ${next} mode`} title={`Switch to ${next} mode`}>
      <Icon name={theme === 'dark' ? 'sun' : 'moon'} />
    </button>
  );
}

// ---------- header / footer ----------
export function SiteHeader({ onLogoClick, right }: { onLogoClick?: () => void; right?: React.ReactNode }) {
  return (
    <header className="bx-header">
      <div className="bx-container bx-header-inner">
        {onLogoClick ? (
          <button type="button" className="bx-logo" onClick={onLogoClick} aria-label="BOQBOX home">
            <img src={logo} alt="BOQBOX" />
          </button>
        ) : (
          <Link to="/" className="bx-logo" aria-label="BOQBOX home">
            <img src={logo} alt="BOQBOX" />
          </Link>
        )}
        <nav className="bx-nav" aria-label="Main">
          <NavLink to="/offers" className="bx-hide-sm">Meal offers</NavLink>
          <NavLink to="/path-selection" className="bx-hide-sm">Subscriptions</NavLink>
        </nav>
        {right}
        <ThemeToggle />
      </div>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="bx-footer">
      <div className="bx-container bx-footer-inner">
        <span>Quick, quiet deliveries across Lagos.</span>
        <nav aria-label="Footer">
          <Link to="/">Home</Link>
          <Link to="/path-selection">Subscriptions</Link>
          <Link to="/offers">Meal offers</Link>
        </nav>
      </div>
    </footer>
  );
}

// ---------- flow page ----------
export interface FlowStep { label: string }

export function Steps({ steps, current }: { steps: string[]; current: number }) {
  return (
    <ol className="bx-steps" aria-label={`Step ${current + 1} of ${steps.length}`}>
      {steps.map((label, i) => (
        <li key={label} className={i < current ? 'done' : i === current ? 'active' : ''} aria-current={i === current ? 'step' : undefined}>
          <span>{i + 1}. {label}</span>
        </li>
      ))}
    </ol>
  );
}

interface FlowPageProps {
  eyebrow?: string;
  title: string;
  subtitle?: React.ReactNode;
  steps?: string[];
  step?: number;
  onBack?: () => void;
  backLabel?: string;
  aside?: React.ReactNode;
  bar?: React.ReactNode;
  barMobileOnly?: boolean;
  narrow?: boolean;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
}

/** Standard page for every checkout step: header, back, title, steps, content, optional summary + action bar. */
export function FlowPage({ eyebrow, title, subtitle, steps, step = 0, onBack, backLabel = 'Back', aside, bar, barMobileOnly, narrow, headerRight, children }: FlowPageProps) {
  return (
    <div className="bx bx-page-enter">
      <SiteHeader right={headerRight} />
      <main className="bx-main">
        <div className={`bx-container${narrow && !aside ? ' bx-container-narrow' : ''}`}>
          <div className="bx-flow-head">
            {onBack ? (
              <button type="button" className="bx-back" onClick={onBack}>
                <Icon name="back" /> {backLabel}
              </button>
            ) : null}
            {eyebrow ? <div className="bx-eyebrow">{eyebrow}</div> : null}
            <h1>{title}</h1>
            {subtitle ? <p>{subtitle}</p> : null}
          </div>
          {steps ? <Steps steps={steps} current={step} /> : null}
          <div className={`bx-layout${aside ? ' with-aside' : ''}`}>
            <div>
              {children}
              {bar ? <div className={`bx-bar${barMobileOnly ? ' mobile-only' : ''}`}>{bar}</div> : null}
            </div>
            {aside ? <aside className="bx-aside">{aside}</aside> : null}
          </div>
        </div>
      </main>
    </div>
  );
}

// ---------- controls ----------
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'soft' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  block?: boolean;
  loading?: boolean;
};

export function Button({ variant = 'primary', size = 'md', block, loading, className = '', children, disabled, ...rest }: ButtonProps) {
  return (
    <button
      type="button"
      className={`bx-btn bx-btn-${variant}${size !== 'md' ? ` bx-btn-${size}` : ''}${block ? ' bx-btn-block' : ''} ${className}`}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? <span className="bx-spinner" /> : null}
      {children}
    </button>
  );
}

export function Field({ label, optional, hint, error, span, children }: { label: string; optional?: boolean; hint?: string; error?: string; span?: boolean; children: React.ReactElement }) {
  const id = React.useId();
  return (
    <div className={`bx-field${span ? ' span-2' : ''}`}>
      <label htmlFor={id}>{label}{optional ? <span className="bx-opt"> (optional)</span> : null}</label>
      {React.cloneElement(children, { id, 'aria-invalid': error ? true : undefined, 'aria-describedby': error || hint ? `${id}-note` : undefined })}
      {error ? <span className="bx-field-error" id={`${id}-note`}>{error}</span> : hint ? <span className="bx-field-hint" id={`${id}-note`}>{hint}</span> : null}
    </div>
  );
}

export function Stepper({ value, onChange, min = 0, max = 99, label, size, tone }: { value: number; onChange: (v: number) => void; min?: number; max?: number; label: string; size?: 'sm'; tone?: 'brand' }) {
  return (
    <span className={`bx-stepper${size ? ` ${size}` : ''}${tone ? ` ${tone}` : ''}`} role="group" aria-label={`${label} quantity`}>
      <button type="button" onClick={() => onChange(value - 1)} disabled={value <= min} aria-label={value - 1 < 1 ? `Remove ${label}` : `Decrease ${label}`}>
        {value <= 1 && min < 1 ? <Icon name="x" size={15} stroke={2.6} /> : '−'}
      </button>
      <span aria-live="polite">{value}</span>
      <button type="button" onClick={() => onChange(value + 1)} disabled={value >= max} aria-label={`Increase ${label}`}>+</button>
    </span>
  );
}

export function Sheet({ title, onClose, children, footer }: { title: string; onClose: () => void; children: React.ReactNode; footer?: React.ReactNode }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);
  return (
    <>
      <div className="bx-sheet-backdrop" onClick={onClose} />
      <div className="bx-sheet" role="dialog" aria-modal="true" aria-label={title}>
        <div className="bx-sheet-grip" />
        <div className="bx-sheet-head">
          <h3>{title}</h3>
          <button type="button" className="bx-icon-btn" onClick={onClose} aria-label="Close"><Icon name="x" /></button>
        </div>
        <div className="bx-sheet-body">{children}</div>
        {footer ? <div className="bx-sheet-foot">{footer}</div> : null}
      </div>
    </>
  );
}

const CATEGORY_EMOJI: Record<string, string> = {
  groceries: '🧺', produce: '🍅', protein: '🥚', breakfast: '🍳', lunch: '🍱', dinner: '🍽️',
  snacks: '🍪', beverages: '🧃', desserts: '🍰', baby: '🍼', subscription: '📦', other: '🛍️',
};
export const categoryEmoji = (category?: string) => CATEGORY_EMOJI[String(category || '').toLowerCase()] || '🛍️';

export function Thumb({ src, category, alt = '', className = '', style }: { src?: string; category?: string; alt?: string; className?: string; style?: React.CSSProperties }) {
  const [failed, setFailed] = React.useState(false);
  return (
    <div className={`bx-thumb ${className}`} style={style}>
      {src && src.trim() && !failed ? (
        <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} />
      ) : (
        <span className="bx-thumb-emoji" aria-hidden="true">{categoryEmoji(category)}</span>
      )}
    </div>
  );
}
